import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import injectSheet from 'react-jss'
import styles from './work-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import ContextMenu from './context-menu/context-menu.container'

const WorkEntry = ({
  classes,
  date,
  title,
  description,
  thumb,
  id,
  match,
  canUpdate
}) => (
  <TableRow>
    <Cell left className={classes.thumbnail}>
      <Link to={match.url + '/' + id} className={classes.titleLink}>
        <span style={{ backgroundImage: `url("${thumb}")` }} />
      </Link>
    </Cell>
    <Cell>{date}</Cell>
    <Cell>
      <Link to={match.url + '/' + id} className={classes.titleLink}>
        {title}
      </Link>
      {description && <p>{description}</p>}
    </Cell>
    {canUpdate && (
      <Cell right>
        <ContextMenu id={id} />
      </Cell>
    )}
  </TableRow>
)

export default withRouter(injectSheet(styles)(WorkEntry))
